'use strict';

import BaseService from './base.service';

class OPHistoriesService extends BaseService {
  /* @ngInject */
  constructor(OperationProcedureHistory, SegaUser) {
    super(OperationProcedureHistory, SegaUser);
    Object.assign(this, {
      OperationProcedureHistory
    });
  }
}

export default OPHistoriesService;
